import {
  ArrowUpOnSquareIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/outline";
import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import FilesRows from "./FilesRows";
import Modal from "./Modal";

export default function UploadFilesModal({ open, onClose, onSubmit }) {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback(acceptedFiles => {
    setFiles(prev => [...prev, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
  });

  const removeFile = idx => {
    setFiles(prev => prev.filter((_, _idx) => _idx !== idx));
  };

  const submit = e => {
    e.stopPropagation();
    e.preventDefault();
    onSubmit(files);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setFiles([]);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      onSubmit={submit}
      title="Upload Files"
      description="Upload files to train your AI Agent, images in files will be ignored. Accepted file types are .pdf, .xlsx, .csv, .docx, etc."
      startIcon={
        <div className="p-2 rounded-xl border">
          <ClipboardDocumentIcon className="size-6" />
        </div>
      }
    >
      <div>
        <div
          className="rounded-xl hover:border-primary border cursor-pointer p-4"
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <div className="flex flex-col items-center gap-4 text-center text-gray-500 text-sm">
            <div className="p-2.5 rounded-xl border">
              <ArrowUpOnSquareIcon className="size-6" />
            </div>

            <div>
              <div>
                <button className="text-primary font-semibold">
                  Click to upload
                </button>
                {` `}
                <span>or drag and drop</span>
              </div>

              <div>CSV, PDF, XLS, XLSX or DOCX (max. 45mb)</div>
            </div>
          </div>
        </div>

        {files.length > 0 && (
          <div className="mt-4">
            <FilesRows files={files} onRemove={removeFile} />
          </div>
        )}
      </div>
    </Modal>
  );
}
